import { makeEndpointFns } from '../fns';
import {
    CartAndStoreDefectRequestQuery,
    CartDefect,
    CartDefectRequestQuery,
    CartTicketCancelRequest,
    CartTicketCreateRequestV2,
    PagedCartDefectResponse,
} from '@whiz-cart/node-shared/models/cart/cartDefect';
import { CartSetupCodeRequest, CartSetupCodeResponse } from '@whiz-cart/node-shared/models/cart/cartSetupCode';
import { DefectTicketSettings } from '@whiz-cart/node-shared/models/defect/ticket';

const { GET, POST } = makeEndpointFns('storeManager');

export const cart = {
    setup: {
        /** Generate code scannable at cart for triggering special behavior */
        generateCodeForSetupService: POST('api/v1/cartSetup/generateCodeForSetupService/{storeGuid}', CartSetupCodeResponse, {
            body: CartSetupCodeRequest,
        }),
        /** Generate code scannable at cart to cause cart to switch to Store Wifi */
        generateStoreWifiCodeForSetupService: POST(
            'api/v1/cartSetup/generateCodeForSetupService/{storeGuid}/setupWifi',
            CartSetupCodeResponse,
        ),
    },

    /** Endpoints relating to cart defect tickets */
    tickets: {
        /** List defects for a specific cart */
        listCartDefects: GET('api/v1/cartTicket/getList/{storeGuid}', PagedCartDefectResponse, {
            query: CartDefectRequestQuery,
        }),

        /** List endpoints for a specific store (& cart) */
        listCartAndStoreDefects: GET('api/v1/cartTicket/getList', PagedCartDefectResponse, {
            query: CartAndStoreDefectRequestQuery,
        }),

        /** Create a new cart defect ticket */
        createCartDefect: POST('api/v1/cartTicket/create', CartDefect, {
            body: CartTicketCreateRequestV2,
        }),

        /** Cancel an existing cart defect ticket  */
        cancelCartDefect: POST('api/v1/cartTicket/cancel', CartDefect, {
            body: CartTicketCancelRequest,
        }),

        /** Get cart ticket settings for a store */
        getTicketSettings: GET('api/v1/cartTicket/ticketSettings/{storeGuid}', DefectTicketSettings),
    },
};
